<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-8 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">Upload Beneficiary Bank Accounts
                        </h2>
                        <div class="breadcrumb-wrapper col-12">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link to="/home">
                                        {{ trans('general.home') }}
                                    </router-link>
                                </li>
                                <li class="breadcrumb-item">
                                    <router-link to="/beneficiary">
                                        {{ trans('beneficiary.beneficiary') }}
                                    </router-link>
                                </li>
                                <li class="breadcrumb-item active">
                                    Bank Accounts
                                </li>


                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-header-right text-md-right col-md-4 col-12 d-md-block d-none">
                <div class="form-group breadcrum-right">
                    <button class="btn btn-primary btn-sm pull-right" @click="$router.push('/beneficiaries/bank-accounts')"><i class="feather icon-list"></i> Bank Account Lists</button>
                    
                </div>
            </div>

        </div>

        <div class="content-body">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Upload Beneficiary Bank Accounts</h4>
                </div>

                <div class="card-content">
                    <div class="card-body">
                        <form @submit.prevent="proceed" @keydown="beneficiaryForm.errors.clear($event.target.name)">
                                    <div class="row">
                                        
        <div class="col-md-12 mb-1">
            <a href="/public/samples/beneficiaries-accounts.xlsx" download class="btn btn-primary btn-sm waves-effect waves-float waves-light pull-left"><i class="fas fa-download"></i> {{ trans('general.download_sample') }}</a>
            
        </div>
            <div class="col-xl-12 col-md-6 col-12">
                <div class="form-group">
                    <label for="">{{trans('beneficiary.cohort')}}</label>
                    <select class="form-control" :class="{ 'is-invalid': beneficiaryForm.errors.has('cohort_id') }" name="cohort_id" v-model="beneficiaryForm.cohort_id">
                        <option value="">{{trans('beneficiary.cohort')}}</option>
                        <option v-for="cohort in cohorts" :value="cohort.id">{{cohort.name}}</option>
                    </select>
                    <show-error :form-name="beneficiaryForm" prop-name="cohort_id"></show-error>
                </div>
            </div>
            <div class="col-xl-6 col-md-6 col-12">
                <div class="form-group">
                    <file-upload-input :button-text="trans('general.excel')" :token="beneficiaryForm.upload_token" module="beneficiary" :clear-file="clear_message_attachment" :module-id="beneficiaryForm.id"></file-upload-input>    
                </div>
            </div>
                                        
                                        
            </div>
            <div class="row">
                <div class="col-md-8 offset-md-4">
                    <button-spinner
                        :is-loading="beneficiaryForm.isLoading" 
                        :disabled="beneficiaryForm.isLoading"
                        
                        class="btn btn-primary mr-1 mb-1 waves-effect waves-light pull-right"
                        style="height: 39px; color: #fff;"
                        >
                        <span>{{trans('general.save')}}</span>
                    </button-spinner>

                    <router-link to="/beneficiaries" class="btn btn-danger waves-effect waves-light pull-right mr-1 mb-1">{{trans('general.cancel')}}</router-link>
        
                </div>
            </div>
        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import fileUploadInput from '../../components/file-upload-input'
    import uuid from 'uuid/v4'

    export default {
        components : { fileUploadInput },
        data() {
            return {
                beneficiaryForm: new Form({
                    isLoading: false,
                    id: '',
                    upload_token: '',
                    cohort_id: ''
                }),
                cohorts: [],
                clear_message_attachment: false,
            };
        },
        mounted(){
            if(!helper.hasPermission('upload-bank-accounts')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('beneficiary')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }
            this.beneficiaryForm.upload_token = uuid();
            this.fetchPreRequisites();
        },
         methods: {
            fetchPreRequisites(){
                axios.get('/api/user/pre-requisite')
                    .then(response => response.data)
                    .then(response => {
                        this.cohorts = response.cohorts;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error)
                    });
            },
            proceed(){
                this.storeUpload();
            },
            storeUpload(){
                this.beneficiaryForm.isLoading = true;
                this.beneficiaryForm.post('/api/beneficiaries/import-bank-accounts')
                    .then(response => {
                        this.beneficiaryForm.isLoading = false;
                        toastr.success(response.message);
                        this.clear_message_attachment = true;
                        this.$router.push('/beneficiaries/bank-accounts');
                    })
                    .catch(error => {
                        this.beneficiaryForm.isLoading = false;
                        toastr.error(error.message);
                        helper.showErrorMsg(error);
                    });
            }
        }
    }
</script>
